export default {
  /**
   * Installs the Vue/Autopilot conduit.
   *
   * @param vue
   * @param options {{window: object, token: string, url: string}}
   */
  install (vue, options) {
    const windowShim = options.window;
    const autopilotToken = options.token;
    const autopilotUrl = options.url;

    (function (o, window, token, url) {
      var b = url;
      var t = token;
      var a = window.AutopilotAnywhere = {
        _runQueue: [],
        run: function () {
          this._runQueue.push(arguments);
        }
      };
      var c = encodeURIComponent;
      var s = 'SCRIPT';
      var d = document;
      var p = 't=' + c(d.title || '') + '&u=' + c(d.location.href || '') + '&r=' + c(d.referrer || '');
      var j = 'text/javascript';
      var z;
      var y;
      if (!window.Autopilot) window.Autopilot = a;
      if (o.app) p = 'devmode=true&' + p;
      z = function (src, asy) {
        var e = d.createElement(s);
        e.type = j;
        e.async = asy;
        e.src = src;
        d.body.appendChild(e);
      };
      y = function () { z(b + t + '?' + p, true); };
      if (window.attachEvent) { window.attachEvent('onload', y); } else { window.addEventListener('load', y, false); }
    })({ app: true }, windowShim, autopilotToken, autopilotUrl);

    vue.prototype.$autopilot = options.window.Autopilot;
  }
};
